/**
 * LabelsPreviewCtrl controller
 *
 * @class LabelsPreviewCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:LabelsPreviewCtrl
 */
/* @ngInject */
export default function LabelsPreviewCtrl ($scope, scope) {
  const vm = this

  vm.platform = scope.platform || 'stb'

  vm.previewTabs = {
    stb: {
      aspectRatio: 1.7756,
      icon: 'fa-television',
      iconSize: 14,
      index: 0
    },
    laptop: {
      aspectRatio: 1.7756,
      icon: 'fa-laptop',
      iconSize: 14,
      index: 1
    },
    tablet: {
      aspectRatio: 1.43,
      icon: 'fa-tablet',
      iconSize: 17,
      index: 2
    },
    mobile: {
      aspectRatio: 0.53,
      icon: 'fa-mobile',
      iconSize: 18,
      index: 3
    }
  }

  vm.screens = {
    stb: require('./assets/screens/labels-preview-stb.jpg'),
    laptop: require('./assets/screens/labels-preview-laptop.jpg'),
    tablet: require('./assets/screens/labels-preview-tablet.jpg'),
    mobile: require('./assets/screens/labels-preview-mobile.png')
  }

  vm.tabConfig = vm.previewTabs[vm.platform]
  vm.activePreviewTabIndex = vm.previewTabs[vm.platform].index
  vm.screenSrc = vm.screens[vm.platform]

  vm.selectPlatform = function (platform) {
    scope.platform = platform
  }

  $scope.$watch(function () {
    return scope.platform
  }, function (platform) {
    vm.platform = platform || 'stb'
    vm.tabConfig = vm.previewTabs[vm.platform]
    vm.activePreviewTabIndex = vm.previewTabs[vm.platform].index
    vm.screenSrc = vm.screens[vm.platform]
  })
}
